module.exports = __webpack_public_path__ + "static/apple-pie-7d9d28d1e2d0d50f047b5c4806d01f19.jpg";